import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { cn } from '../lib/cn';

/**
 * Markdown (notatki, decyzje, treści od AI). Zawsze przez rehype-sanitize: bez skryptów, styli i zdarzeń.
 * Linki zewnętrzne otwierają się w nowej karcie z rel="noopener noreferrer".
 */
export function Markdown({ children, className }: { children: string; className?: string }) {
  return (
    <div
      className={cn(
        'text-body-m text-fg',
        '[&_p]:my-3 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0',
        '[&_h1]:mt-6 [&_h1]:mb-3 [&_h1]:text-h3 [&_h2]:mt-6 [&_h2]:mb-2 [&_h2]:text-h4',
        '[&_h3]:mt-5 [&_h3]:mb-2 [&_h3]:text-body-m [&_h3]:font-semibold',
        '[&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-1',
        '[&_a]:text-accent [&_a]:underline-offset-2 hover:[&_a]:underline',
        '[&_code]:rounded-xs [&_code]:bg-surface [&_code]:px-1 [&_code]:font-mono [&_code]:text-[0.9em]',
        '[&_pre]:my-3 [&_pre]:overflow-x-auto [&_pre]:rounded-lg [&_pre]:bg-surface [&_pre]:p-3 [&_pre_code]:bg-transparent [&_pre_code]:p-0',
        '[&_blockquote]:my-3 [&_blockquote]:border-l-2 [&_blockquote]:border-line-strong [&_blockquote]:pl-3 [&_blockquote]:text-fg-secondary',
        '[&_hr]:my-6 [&_hr]:border-line',
        '[&_table]:my-3 [&_table]:w-full [&_table]:text-body-s [&_th]:border-b [&_th]:border-line [&_th]:py-1.5 [&_th]:text-left [&_th]:font-medium [&_td]:border-b [&_td]:border-line [&_td]:py-1.5',
        '[&_input[type=checkbox]]:mr-1.5 [&_input[type=checkbox]]:accent-[var(--accent-primary)]',
        className,
      )}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          a: ({ href, children: linkChildren }) => {
            const external = typeof href === 'string' && /^https?:\/\//.test(href);
            return (
              <a href={href} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                {linkChildren}
              </a>
            );
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
